<template>
  <div>
    <div style="margin: 50px 150px">
      <iframe src="https://plantpp.ai4breeding.com/profile/upload/file/help.pdf" style="width:100%;height:85vh" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

</style>
